import theme from "../theme";

const useGlobalTheme = () => {
  return theme;
};

export default useGlobalTheme;
